module.exports = __webpack_public_path__ + "img/73.80fb6a5b.jpg";